<template>
  <div>
    <img class="img" src="/assets/image/trumpet_start.gif" alt="音頻播放中">
  </div>
</template>

<script>
export default {
  name: "TestTrumpetStart"
}
</script>

<style scoped>
.img {
  display: block;
  width: 100%;
}
</style>
